// Pieces in other stores for each size of one colour that is out in this store,
// so a sold-out size can say "4 nearby" instead of just "Out". Online only;
// a failed lookup leaves the size without a count. { [size]: number }.
import { useEffect, useMemo, useState } from "react";
import { getProductsNearbyStockService } from "../../../../services";
import { findVariant } from "../../../../utils/fashion/styleIndex";
import { buildNearbyStockRequest, localStockLabel, nearbyTotal, parseNearbyStores } from "../../../../utils/fashion/storeStock";

const NONE = {};

export const sizeKey = (s) => s ?? "One size";

export default function useNearbyCounts(style, colour, tillData, isOnline) {
  const online = typeof isOnline === "boolean" ? isOnline : typeof navigator === "undefined" || navigator.onLine;
  const outSizes = useMemo(() => {
    const list = style.sizes.length > 0 ? style.sizes : [null];
    return list
      .map((s) => ({ size: s, variant: findVariant(style, colour, s) }))
      .filter((x) => x.variant && localStockLabel(x.variant)?.startsWith("Out"));
  }, [style, colour]);
  const [counts, setCounts] = useState(NONE);

  useEffect(() => {
    setCounts(NONE);
    if (!online || outSizes.length === 0 || !tillData?.tillAccess?.csBunit?.csBunitId) return undefined;
    let live = true;
    Promise.all(
      outSizes.map(({ size, variant }) =>
        getProductsNearbyStockService(buildNearbyStockRequest(tillData, variant.value))
          .then((res) => [sizeKey(size), nearbyTotal(parseNearbyStores(res, tillData))])
          .catch(() => [sizeKey(size), null])
      )
    ).then((pairs) => {
      if (!live) return;
      setCounts(Object.fromEntries(pairs.filter(([, n]) => n !== null)));
    });
    return () => {
      live = false;
    };
  }, [outSizes, online]); // eslint-disable-line react-hooks/exhaustive-deps

  return counts;
}
